import { useTranslation } from "react-i18next";

const Growth = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="container h-[700px]">
        <h1 className="text-center text-5xl font-bold my-10">
          {t("growWithZayverse")}
        </h1>
        <div className="content">
          <div className="grid grid-cols-2 gap-10 min-h-[600px]">
            <div
              className="flex flex-col items-center gap-6 relative"
              id="left-side"
            >
              <div className="h-60 w-1/2 absolute right-40 top-0">
                <img
                  src="https://i.pinimg.com/1200x/6a/e0/e1/6ae0e15ecb9d22b59e8aabe44c2098b4.jpg"
                  alt={t("growthImage1Alt")}
                  className="rounded-xl"
                />
              </div>

              <div className="z-1 bg-[#E4D9FF] rounded-xl h-60 w-1/2 absolute left-80 top-40">
                <img
                  src="https://i.pinimg.com/1200x/11/35/c2/1135c20db7482dd894f31198156aac66.jpg"
                  alt={t("growthImage2Alt")}
                  className="rounded-xl"
                />
              </div>
              <div className="z-2 h-60 w-1/2 absolute righ-40 top-80">
                <img
                  src="https://i.pinimg.com/736x/ca/7c/f5/ca7cf5986266ae5f36a1c31e9ce2ce09.jpg"
                  alt={t("growthImage3Alt")}
                  className="rounded-xl"
                />
              </div>
            </div>
            <div
              className="flex flex-col justify-center items-center text-center"
              id="right-side"
            >
              <h2 className="text-2xl font-bold mb-6">
                {t("doubleRewardsDoubleImpact")}
              </h2>
              <p className="text-gray-500 mb-8 max-w-md font-semibold text-justify text-xl">
                {t("doubleRewardsDescription")}
              </p>
              <button className="custom-box-shadow custom-darkblue-button">
                {t("learnMore")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Growth;
